export const FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID = "FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID";
export const FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS = "FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS";
export const FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE = "FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE";
